import React from 'react'

const FlashIcon = () => {
  return (
    <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg" className='mr-1'>
        <g>
            <path className='chainboard-icon-flash' d="M2.8747 0H5.64135C5.76769 0 5.84762 0.145055 5.78058 0.257876L3.7462 3.66667H5.83731C5.97654 3.66667 6.05132 3.8359 5.96107 3.94603L0.322053 10.9355C0.200867 11.086 -0.0311912 10.9409 0.0435832 10.7582L2.00577 5.90159H0.221495C0.0564753 5.90159 -0.0518186 5.71893 0.0229558 5.56581L2.62717 0.161172C2.67358 0.0617827 2.77156 0 2.8747 0Z"/>
        </g>
    </svg>
  )
}

export default FlashIcon